import { createContext, useContext } from 'react'

import { UseDriverReturn } from './libs/useDriver'

export type DriverContextType = UseDriverReturn

export const DriverContext = createContext<DriverContextType>({
  driverInstance: null,
  startTour: () => {},
  moveToNextStep: () => {},
  getTourState: () => undefined,
  setSteps: () => {},
  setConfig: () => {},
})

export const useDriverContext = () => {
  const context = useContext(DriverContext)

  if (context === undefined) {
    throw new Error(
      'useDriverContext must be used within a DriverContext.Provider',
    )
  }

  return context
}
